import { normalizeListing } from './normalizeListing';

export function normalizeQuote(rawQuote) {
  if (!rawQuote || typeof rawQuote !== 'object') return rawQuote;

  const quote = { ...rawQuote };
  const id = quote.id || quote._id || null;
  const listingCandidate =
    quote.listing && typeof quote.listing === 'object'
      ? quote.listing
      : quote.listingId && typeof quote.listingId === 'object'
        ? quote.listingId
        : null;

  return {
    ...quote,
    _id: quote._id || id,
    id,
    listingId:
      typeof quote.listingId === 'string'
        ? quote.listingId
        : quote.listingId?._id || quote.listingId?.id || quote.listingId || null,
    netPrice: quote.netPrice ?? quote._netPrice ?? quote.price ?? null,
    vatRate: quote.vatRate ?? quote._vatRate ?? 0,
    grossPrice: quote.grossPrice ?? quote._grossPrice ?? quote.totalPrice ?? null,
    minNetPrice: quote.minNetPrice ?? quote._minNetPrice ?? null,
    description: quote.description || quote._description || quote.message || '',
    proposedPickupDate: quote.proposedPickupDate || null,
    proposedDeliveryDate: quote.proposedDeliveryDate || null,
    quoteExpiresAt: quote.quoteExpiresAt || null,
    sharesTracking: Boolean(quote.sharesTracking),
    vehicleTruckId: quote.vehicleTruckId || null,
    vehicleLabel: quote.vehicleLabel || null,
    source: quote.source || 'partner_quote',
    status: (quote.status || quote._status || 'pending').toLowerCase(),
    listing: listingCandidate ? normalizeListing(listingCandidate) : quote.listing,
    partnerScore: quote.partnerScore ?? null,
    partnerRating: quote.partnerRating ?? null,
    partnerReviewCount: quote.partnerReviewCount ?? 0,
    partnerName: quote.partnerName || null,
  };
}

export function normalizeQuoteList(payload) {
  if (!Array.isArray(payload)) return [];
  return payload.map(normalizeQuote);
}
